<template>
    <v-container>
        <div class="d-flex" style="margin-bottom: 20px; margin-top: 10px">
            <div class="text-h3">Группы устройств</div>
            <v-spacer />
            <v-btn @click.stop="add">
                <v-icon>mdi-plus</v-icon>
                Группа
            </v-btn>
        </div>

        <DeviceGroupEditor v-show="editingGroup" v-model="editingGroup" @finish="editFinished" />

        <DeviceGroupBrowser
            ref="browser"
            :filters="{}"
            @edit="e => loadAndEdit(e.id)"
        />
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import {Inject, Prop} from 'vue-property-decorator'
import Api from '@/services/Api'
import DeviceGroupEditor from '@/components/modals/DeviceGroupEditor.vue'
import {createDeviceGroup, DeviceGroupDraft} from '@/models/DeviceGroup'
import DeviceGroupBrowser from '@/components/browsers/DeviceGroupBrowser.vue'

@Component({
    components: {DeviceGroupBrowser, DeviceGroupEditor},
})
export default class DeviceGroupsView extends Vue
{
    @Inject('api') private api!: Api

    @Prop({type: Boolean, default: false})
    isCreating!: boolean

    editingGroup: DeviceGroupDraft | null = null

    async created() {
        if (this.isCreating) {
            this.add()
        } else {
            const id = parseInt(this.$route.params.id)
            if (id) {
                await this.loadAndEdit(id)
            }
        }
    }

    async fetchOne(id: number) {
        return await this.api.getDeviceGroup(id)
    }

    async loadAndEdit(id: number) {
        const group = await this.fetchOne(id)
        this.edit(group)
    }

    add() {
        this.edit(createDeviceGroup())
    }

    edit(group: DeviceGroupDraft) {
        this.editingGroup = group
        this.$router.push(group.id ? '/device-groups/edit/' + group.id : '/device-groups/create').catch(() => true)
    }

    editFinished() {
        this.editingGroup = null
        const browser = this.$refs.browser as DeviceGroupBrowser
        browser.refresh()
        this.$router.push('/device-groups')
    }
}
</script>
